function findQualifyingPromotions(product) {
    const now = new Date(); // Current date for comparison
    const currentMarketID = `gid://shopify/Market/${countryMarketId}`; // Global variable representing the current market ID
    return promotions.filter(promo => {
        // Check if the promotion is active
        const isActive = promo.active;

        // Check if the promo is enabled via front-end Config
        const isFrontendconfigTrue = promo.frontendConfig;

        // Exclude order-level promotions immediately if the namespace check fails
        const isProductLevelPromotion = promo.promoObject.metafields.some(metafield => metafield.namespace === "$app:product-discount");
        if (!isProductLevelPromotion) {
            return false; // Immediately return false, skipping this promotion
        }

        const disallowedPromosOnNonBookProducts = ["gid://shopify/DiscountAutomaticNode/1456558145809", "gid://shopify/DiscountAutomaticNode/1456560242961"];
        if (disallowedPromosOnNonBookProducts.includes(promo.discountId) && ((product.productType && product.productType !== 'Book') || (product.sku && !/^GOR|CIN/.test(product.sku)))) {
            return false;
        }

        // Check if the promotion is within the date range
        const startsAt = new Date(promo.promoObject.startsAt);
        const endsAt = promo.promoObject.endsAt ? new Date(promo.promoObject.endsAt) : new Date("9999-12-31");
        const isInDateRange = now >= startsAt && now <= endsAt;

        // Check if the current market matches the promotion's market
        const isCorrectMarket = promo.promoObject.metafields[0].value.market.id === currentMarketID;

        // Determine qualifying criteria for condition
        let productCondition = 'used';
        // Data from Algolia for product cards
        if (product.availableConditions && product.availableConditions.length === 1 && product.availableConditions[0].toUpperCase() === 'NEW') {
            productCondition = 'new';
        }
        // Data from Shopify for product variant selector
        if (product.condition && product.condition.toUpperCase() === 'NEW') {
            productCondition = 'new';
        }
        let isCorrectCondition;
        if (promo.promoObject.metafields[0].value.xSelector === "collections") {
            isCorrectCondition = true;
        } else {
            isCorrectCondition = promo.promoObject.metafields[0].value.xSelector === productCondition;
        }

        // Determine qualifying criteria for collections if specified
        // Collection qualification check
        let qualifiesForCollection = true;
        if (promo.promoObject.metafields[0].value.collections && promo.promoObject.metafields[0].value.collections.length > 0) {
            const promoCollectionNumericIds = promo.promoObject.metafields[0].value.collections.map(fullId => fullId.split('/').pop());
            qualifiesForCollection = product.collection_ids.some(id => promoCollectionNumericIds.includes(id.toString()));
        }

        // Check price qualification either by Direct Price Range or xValue for Multi-buy
        const qualifiesForPrice = checkPriceQualification(product, promo);

        // Collect creative details for qualifying promotions
        if (isCorrectCondition && isActive && isInDateRange && isCorrectMarket && qualifiesForCollection && qualifiesForPrice && (isFrontendconfigTrue === 'true' || isFrontendconfigTrue === '')) {
            return {
                title: promo.title,
                message: promo.message,
                color: promo.color,
                fontColor: promo.fontColor
            };
        } else {
            return false;
        }
    }).filter(Boolean); // Filter out any non-qualifying promotions
}

// Assuming the 'product' object and a 'promo' object from your promotions array are available

// Function to check price qualification
function checkPriceQualification(product, promo) {
    const {priceFrom, priceTo, xValue, xAmountTypeSelector} = promo.promoObject.metafields[0].value;
    const productPrice = parseFloat(product.fromPrice);

    // Default to true if no price condition is specified
    let qualifiesForDirectPriceRange = true;
    if (priceFrom || priceTo) {
        const minPrice = priceFrom ? parseFloat(priceFrom) : -Infinity;
        const maxPrice = priceTo ? parseFloat(priceTo) : Infinity;
        qualifiesForDirectPriceRange = productPrice >= minPrice && productPrice <= maxPrice;
    }

    let qualifiesForXValue = true;
    if (xValue?.amount && xAmountTypeSelector) {
        const xPrice = parseFloat(xValue.amount);
        switch (xAmountTypeSelector) {
            case 'xValueRange':
                // Example logic for range; adjust as necessary
                qualifiesForXValue = productPrice >= parseFloat(xValue.min) && productPrice <= parseFloat(xValue.max);
                break;
            case 'xValueAbove':
                qualifiesForXValue = productPrice > xPrice;
                break;
            case 'xValueUnder':
                qualifiesForXValue = productPrice < xPrice;
                break;
            default:
                break; // Keep as true if unrecognized
        }
    }

    return qualifiesForDirectPriceRange && qualifiesForXValue;
}